import React, { useEffect, useState } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { useQuery } from "react-query";

import { motion } from "framer-motion";
import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Work.scss";
import SorryMessage from "../../components/SorryMessage/SorryMessage";
import Model from "../../components/Modal/Model";
import placeholder from "../../assets/1200.png";

// "Games",

const Work = () => {
  // State to handle the active filter clicked by the user.
  const [activeFilter, setActiveFilter] = useState("All");
  // state to change the animation of work cards according to the change of active one.
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [selectedProject, setSelectedProject] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  // using useQuery hook.
  const { status } = useQuery("work", async () => {
    const query = '*[_type == "works"]';
    const data = await client.fetch(query);
    setWorks(data);
    setFilterWork(data);
    setActiveFilter("All");
  });

  // Handling the work filter function.
  const handleWorkFilter = (item) => {
    setActiveFilter(item);

    // changing the y to trigger the change of item animation.
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
      setAnimateCard([{ y: 0, opacity: 1 }]);
    }, 500);
  };

  const showModel = (id) => {
    setSelectedProject(works.find((work) => work._id === id));
    setIsOpen(true);
  };

  useEffect(() => {
    let sub = true;
    if (sub) {
      document.addEventListener("click", () => {
        if (isOpen) {
          setIsOpen(false);
        }
        return null;
      });
    }

    return () => {
      sub = false;
    };
  }, [isOpen]);

  return (
    // < className="app__works app__flex">
    <div className="app__work__parent">
      <Model isOpen={isOpen} setIsOpen={setIsOpen} content={selectedProject} />
      <h2 className="head-text">
        My Creative <span>Work</span> Section
      </h2>

      <div className="app__work-filter">
        {["E-commerce", "Social Media", "Apps", "Landing Page", "All"].map(
          (item, index) => (
            <div
              key={index}
              onClick={() => handleWorkFilter(item)}
              className={`app__work-filter-item app__flex p-text ${
                activeFilter === item ? "item-active" : ""
              }`}
            >
              {item}
            </div>
          )
        )}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.length > 0 && status === "success" ? (
          filterWork.map((work, index) => (
            <div className="app__work-item app__flex" key={index}>
              <div className="app__work-img app__flex">
                <img
                  src={urlFor(work.imgUrl) || placeholder}
                  alt={work.title}
                  loading="lazy"
                />

                {/* remaining card data */}
                <div className="app__work-hover app__flex">
                  {/* when you used _blank it is better to set the rel to -> noreferrer */}
                  {/* here will have the links for the site or it's code */}
                  <a
                    href={work.projectLink}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="have a look at the site"
                  >
                    <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.9] }}
                      transition={{ duration: 0.25 }}
                      className="app__flex"
                    >
                      <AiFillEye />
                    </motion.div>
                  </a>
                  {/* Second icon for the code */}
                  {/* {console.log(work.codeLink)} */}
                  {work.codeLink !== undefined && (
                    <a
                      href={work.codeLink}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="have a look at the code"
                    >
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{ duration: 0.25 }}
                        className="app__flex"
                      >
                        <AiFillGithub />
                      </motion.div>
                    </a>
                  )}
                </div>
              </div>

              {/* create the div for title and description */}
              <div className="app__work-content app__flex">
                <h3 className="bold-text">{work.title}</h3>
                {/* <p className="p-text" style={{ marginTop: 10 }}>
                  {work.description}
                </p> */}
                <button
                  className="app__work-content--btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    showModel(work._id);
                  }}
                >
                  More!
                </button>

                {/* now render the tags */}
                <div className="app__work-tag app__flex">
                  <p className="p-text">{work.tags[0]}</p>
                </div>
              </div>
            </div>
          ))
        ) : filterWork.length === 0 && status === "success" ? (
          <div>
            <h3
              style={{
                fontWeight: "bold",
                color: "#06d6a0",
                textAlign: "center",
              }}
            >
              No work found
            </h3>
          </div>
        ) : (
          <SorryMessage />
        )}
      </motion.div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
// MotionWrap(Work, "app__works")
